import React, { useState } from 'react';
import Navbar from './navbar';
import Sidebar2 from './sidebar2';
import Sidebar from './sidebar';

const MainLayout = ({ children }: { children: React.ReactNode, isLoading?: boolean }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  return (

    <div className={`flex flex-col
        transition-all duration-300
        ${isSidebarOpen ? 'pl-[240px]' : 'pl-[80px]'}
    `}>
        {/* <Sidebar /> */}
        <Sidebar2 onSidebarOpen={setIsSidebarOpen} />
        <Navbar />
        <div className='relative bg-[#e3ebf6] w-full flex flex-col' style={{ minHeight: 'calc(100vh - 72px)', top: '72px',}}>
            {children}
        </div>
        
    </div>
  )
}

export default MainLayout